import React from "react";
import Box from "@mui/material/Box";
import { UserData } from "types/models/master/MasterApp";
import { Fonts } from "shared/constants/AppEnums";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface UserProps {
  user: UserData;
  onBack?: () => void;
}

const UserHeader: React.FC<UserProps> = ({ user, onBack }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    }
    navigate("/master/manageUser/users");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBackClick}
          sx={{
            textTransform: "none",
            color: "black",
            padding: 0,
            minWidth: "auto",
          }}
        />
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            ml: 0.5,
            mb: { xs: 1, sm: 0 },
          }}
        >
          {user ? "Add New User" : "Add New User"}
        </Box>
      </Box>
    </Box>
  );
};

export default UserHeader;
